module.exports = __webpack_public_path__ + "img/np_data_629880_F0CD5E.1ca1342e.svg";